import { Container, Divider, Grid } from '@material-ui/core'
import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { useForm, FormContext } from 'react-hook-form'
import { ACTIONS, PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { Action } from '../../../../models/Action'
import { awaitWithLoading, capitalizeFirstLetter } from '../../../../services/utils'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'
import { OwnerProfileSection } from './OwnerProfileSection'
import { OwnerAddressSection } from './OwnerAddressSection'
import policyModificationApi from '../../../../api/policyModification.api'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService'
import { OwnerHistorySection } from './OwnerHistorySection'
import { SessionContextStore } from '../../../../context/SessionContext'
import dayjs from 'dayjs'

export const OwnerDetailsModification = ({ onContinue, tabIndex }) => {
  const modifyContext = useContext(PolicyModificationContextStore)
  const sessionContext = useContext(SessionContextStore)
  const ownerDetailes = modifyContext.owner_details

  const form = useForm({ mode: 'onBlur', defaultValues: { ...ownerDetailes } })

  const saveOwnerChanges = async data => {
    const formattedData = {
      ...data,
      date_of_birth: dayjs(data.date_of_birth).format('YYYY-MM-DD'),
      first_name: capitalizeFirstLetter(data.first_name.toLowerCase()),
      last_name: capitalizeFirstLetter(data.last_name.toLowerCase()),
      insurance_id: modifyContext.insuranceId,
    }

    const res = await awaitWithLoading(policyModificationApi.validatePolicyOwnerData(formattedData))
    if (res.ok) {
      modifyContext.dispatch(new Action(ACTIONS.SAVE_OWNER_DETAILS, formattedData))
      onContinue(tabIndex)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  return (
    <React.Fragment>
      <FormContext {...form}>
        <form autoComplete="off" onSubmit={form.handleSubmit(saveOwnerChanges)}>
          <Container className="margin-top-medium">
            <OwnerProfileSection isRenewal={modifyContext.isRenewal} />
            <Divider />
            <OwnerAddressSection />
            {!modifyContext.isRenewal && sessionContext.activeInsurance?.tenure === 0 && (
              <>
                <Divider />
                <OwnerHistorySection />
              </>
            )}
            <Grid xs={4}>
              <FlexView vAlignContent="center" hAlignContent="left" className="margin-top-large">
                <ContinueButton label="Continue" type="submit" />
              </FlexView>
            </Grid>
          </Container>
        </form>
      </FormContext>
    </React.Fragment>
  )
}
